import { useEffect, useState } from "react";
import { Cookie } from "lucide-react";

const GA_ID = "G-NCVZ7WFR5F";
const STORAGE_KEY = "aims_cookie_consent";

// Injects GA4 (gtag.js) only when called — i.e. after the visitor consents.
const loadAnalytics = () => {
  if (window.__gaLoaded) return;
  window.__gaLoaded = true;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = gtag;
  gtag("js", new Date());
  gtag("config", GA_ID);
};

export const CookieConsent = () => {
  const [visible, setVisible] = useState(false);
  const [shown, setShown] = useState(false); // controls entrance transition

  useEffect(() => {
    const choice = localStorage.getItem(STORAGE_KEY);
    if (choice === "accepted") {
      loadAnalytics();
    } else if (!choice) {
      setVisible(true);
      const t = setTimeout(() => setShown(true), 50);
      return () => clearTimeout(t);
    }
  }, []);

  const close = (choice) => {
    localStorage.setItem(STORAGE_KEY, choice);
    if (choice === "accepted") loadAnalytics();
    setShown(false);
    setTimeout(() => setVisible(false), 350);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-consent"
      className={`fixed bottom-4 left-4 right-4 sm:right-auto z-[60] max-w-md rounded-2xl bg-void ring-1 ring-hairline shadow-[0_30px_70px_-24px_rgba(10,27,63,0.45)] p-5 sm:p-6 transition-all duration-300 ease-out ${
        shown ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
      }`}
    >
      <div className="flex items-start gap-3">
        <span className="glossy-icon grid place-items-center w-10 h-10 rounded-xl shrink-0">
          <Cookie className="w-5 h-5 text-white" strokeWidth={2} />
        </span>
        <div>
          <h3 className="font-heading uppercase tracking-tight text-base text-stark">Cookies</h3>
          <p className="mt-1.5 text-sm text-concrete leading-relaxed">
            We use analytics cookies to understand how visitors use our site and improve it.
            No cookies are set unless you accept.
          </p>
        </div>
      </div>
      <div className="mt-5 flex gap-3">
        <button
          type="button"
          data-testid="cookie-accept"
          onClick={() => close("accepted")}
          className="flex-1 rounded-full bg-brand text-white font-heading uppercase tracking-tight text-sm py-2.5 hover:bg-brand/90 active:scale-[0.98] transition-all duration-200"
        >
          Accept
        </button>
        <button
          type="button"
          data-testid="cookie-decline"
          onClick={() => close("declined")}
          className="flex-1 rounded-full bg-surface text-stark ring-1 ring-hairline font-heading uppercase tracking-tight text-sm py-2.5 hover:bg-hairline/40 active:scale-[0.98] transition-all duration-200"
        >
          Decline
        </button>
      </div>
    </div>
  );
};
